import { panelHeadSx, panelSx } from 'shared/config/Styles';

/** 검수 화면의 Document Info·Line Items 카드. 회색 바탕 위에 흰 카드를 얇은 테두리로 구분한다. */
export const reviewPanelSx = { ...panelSx, borderRadius: '6px', boxShadow: 'none', border: '1px solid #e1e6ea' };

/** 검수 화면 카드의 제목 줄. 카드와 같은 흰 바탕에 아래 구분선만 둔다. */
export const reviewPanelHeadSx = { ...panelHeadSx, bgcolor: 'white', borderBottom: '1px solid #e6ebee', px: 2, py: '5px' };

/** 검수 화면 표(당사자 대조·Line Items)의 머리 바탕. */
export const REVIEW_TABLE_HEAD_BG = '#f5f7f8';
